/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import {
    downFile,
    postAction
} from '@/api/manage'

import {
    userqueryById,
    useredit,
} from "@/api/api";
export const BaseMixin = {
    data() {
        return {
            userinfo: this.$store.state.userinfo
        }
    },
    props: {

    },
    watch: {

    },
    created() {
        // console.log(this.$store.state.userinfo);
        // this.$store.commit("setloginstate", true); //设置登录
    },
    computed: {
        //token header
        tokenHeader() {
            let head = {
                'X-Access-Token': this.$Ls.get('token')
            }
            return head;
        }
    },
    methods: {
        logout() {
            this.$message.warning('正在退出登录。。。');
            this.$store.dispatch("llogout").then((res) => {
                // console.log(res);
                if (res.success) {
                    this.$message.success(res.message);
                    this.$store.commit("setloginstate", true);
                } else {
                    this.$message.error(res.message);
                };
            });
        },
        //时间格式化
        settimestring(time) {
            let date = new Date(time);
            let YYYY = date.getFullYear(); //年
            let MM =
                date.getMonth() + 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1; //月
            let dd = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(); //日
            let hh = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(); //时
            let mm =
                date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(); //分
            let ss =
                date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds(); //秒
            let text = `${YYYY}年${MM}月${dd}日 ${hh}:${mm}:${ss}`;
            return text;
        },
        topath(path, query) {
            this.$router.push({
                path: path,
                query: {
                    ...query
                }
            })
        },
        // setuserinfo() {
        //     this.$store.dispatch("setselectUserInfo").then((res) => {
        //         this.userinfo = res.result
        //     });

        // },
        // 导出
        handleExportXls(fileName) {
            if (!fileName || typeof fileName != "string") {
                fileName = "导出文件"
            }
            //console.log("导出参数", param)
            downFile(this.url.exportXlsUrl).then((data) => {
                if (!data) {
                    this.$message.warning("文件下载失败")
                    return
                }
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(new Blob([data], {
                        type: 'application/vnd.ms-excel'
                    }), fileName + '.xls')
                } else {
                    let url = window.URL.createObjectURL(new Blob([data], {
                        type: 'application/vnd.ms-excel'
                    }))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', fileName + '.xls')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }
            })
        },
        /* 导入 */
        handleImportExcel(info, name) {
            // this.loading = true;
            if (info.file.status !== 'uploading') {
                //console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                // this.loading = false;
                // console.log('-----------')
                // console.log(info)
                if (info.file.response.success) {
                    // this.$message.success(`${info.file.name} 文件上传成功`);
                    if (info.file.response.code === 201) {
                        let {
                            message,
                            result: {
                                msg,
                                fileUrl,
                                fileName
                            }
                        } = info.file.response
                        let href = process.env.VUE_APP_API_BASE_URL + fileUrl
                        let div = `<div>
                            <span> ${msg} </span><br />
                            <span> 具体详情请 <a href=${href}
                              target="_blank"
                              download=${fileName} > 点击下载 </a> </span >
                          </div>`
                        this.$warning({
                            title: message,
                            content: (div)
                        })
                    } else {
                        if (name == 'information') {
                            if (info.file.response.result.old.length == 0) {
                                this.$message.success(info.file.response.message || `${info.file.name} 文件上传成功`)
                            } else {
                                this.successCount = info.file.response.result.newNum;
                                this.copyCount = info.file.response.result.oldNum;
                                this.daorulist = info.file.response.result.old;
                                this.daoruVisible = true;
                            }
                        } else {
                            this.$message.success(info.file.response.message || `${info.file.name} 文件上传成功`)
                        }
                    }
                    // this.loadData()
                } else {
                    this.$message.error(`${info.file.name} ${info.file.response.message}.`);
                }
            } else if (info.file.status === 'error') {
                this.loading = false;
                if (info.file.response.status === 500) {
                    let data = info.file.response
                    const token = this.$store.state.token
                    if (token && data.message.includes("Token失效")) {
                        Message.error('很抱歉，登录已过期，请重新登录');
                        if (token) {
                            store.commit("setuserinfo", null);
                            store.commit("settoken", null);
                        }
                        setTimeout(() => {
                            this.$router.push({
                                path: '/Login'
                            })
                        }, 1500);
                    }
                } else {
                    this.$message.error(`文件上传失败: ${info.file.msg} `);
                }
            }
        },
    },
}